module.exports = __webpack_public_path__ + "static/media/Ramsay Bolton 2.b663dc70.jpg";